// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"889":"ef41d607","940":"3f06f9d3"}[chunkId] + ".chunk.css";
};